import { Home, Truck, Package, ShoppingBag, Tag, Archive } from 'lucide-react';
import { Badge } from '@/components/ui';
import type { ItemStatus } from '@/lib/types';

// Compact, non-wrapping status pills: icon + short label so "In Closet" etc.
// never line-breaks in a narrow card.
const CONFIG: Record<
  ItemStatus,
  { tone: 'neutral' | 'accent' | 'success' | 'warning' | 'danger'; label: string; icon: typeof Home }
> = {
  'in-closet': { tone: 'success', label: 'In Closet', icon: Home },
  'out-for-service': { tone: 'warning', label: 'In Service', icon: Truck },
  'pending-delivery': { tone: 'accent', label: 'Incoming', icon: Package },
  wishlist: { tone: 'accent', label: 'Wishlist', icon: ShoppingBag },
  'for-sale': { tone: 'neutral', label: 'For Sale', icon: Tag },
  archived: { tone: 'danger', label: 'Removed', icon: Archive },
};

export function StatusBadge({ status }: { status: ItemStatus }) {
  const c = CONFIG[status] ?? CONFIG['in-closet'];
  const Icon = c.icon;
  return (
    <Badge tone={c.tone} className="whitespace-nowrap flex-shrink-0">
      <Icon className="w-3 h-3" />
      {c.label}
    </Badge>
  );
}
